import { batchedSubscribe } from 'redux-batched-subscribe';
import State from './state';

export default batchedSubscribe(freshNotify => {
  if (!State.notify) {
    freshNotify();
  }
  State.notify = freshNotify;
});
